var _circle, _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "url(#paint0_linear_2755_28812)",
    fillOpacity: 0.36
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.15 33.11V18.89C24.15 17.54 23.58 17 22.14 17H18.51C17.07 17 16.5 17.54 16.5 18.89V33.11C16.5 34.46 17.07 35 18.51 35H22.14C23.58 35 24.15 34.46 24.15 33.11Z",
    fill: "#272C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5001 33.11V18.89C34.5001 17.54 33.9301 17 32.4901 17H28.8601C27.4301 17 26.8501 17.54 26.8501 18.89V33.11C26.8501 34.46 27.4201 35 28.8601 35H32.4901C33.9301 35 34.5001 34.46 34.5001 33.11Z",
    fill: "#272C36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_28812",
    x1: 60.775,
    y1: -16.575,
    x2: -8.775,
    y2: 62.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2E7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.0a20ae1a646b6a8d041247a904f93284.svg";
export { ForwardRef as ReactComponent };